module.exports = __webpack_public_path__ + "media/images/michi-10d6e7e78455737f80b48ea4454f02d8.jpg";